import { ComponentProps } from 'react'
import { styled, theme, ColorTokens, SizeTokens } from 'stitches.config'
import type { IconName } from './iconNames'

const size = Object.keys(theme.sizes).reduce(
  (acc, cv) => ({
    ...acc,
    [cv]: { size: `$${cv}` },
  }),
  {}
) as { [key in SizeTokens]: any } // TODO: Use InternalCSS

const IconRoot = styled('svg', {
  width: '$sm',
  height: '$sm',
  flexShrink: 0,
  flexGrow: 0,
  fill: 'currentColor',
  variants: {
    size,
  },
  defaultVariants: {
    size: '3',
  },
})

type IconOwnProps = ComponentProps<typeof IconRoot>
export type IconProps = IconOwnProps & {
  name: IconName
  color?: ColorTokens
  label?: string
}

export const Icon = ({ name, label, color, css, ...props }: IconProps) => {
  const iconColor = color ? `$${color}` : undefined
  return (
    <IconRoot
      css={{ color: iconColor, fill: iconColor, ...(css as any) }}
      role={label ? 'img' : 'presentation'}
      aria-label={label}
      {...props}
    >
      {/* {label && <title>{label}</title>} */}
      <use xlinkHref={`/icon-sprite.svg#${name}`} />
    </IconRoot>
  )
}
